import React, { useState, useEffect, useRef } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import "./Inbox.css";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
import { Mailbox } from "react-bootstrap-icons";

export default function Inbox({closeNoteAndInbox}) {
  const [convos, setConvos] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuthContext();
  const [skip, setSkip] = useState(0);
  const [noMoreMessages, setNoMoreMessages] = useState(false);

  const navi = useNavigate();
  const inboxRef = useRef(null);

  const ViewMoreNConvos = async () => {
    const newSkip = skip + 25;

    const convoResponse = await axios.get(
      `${ApiConnectionString}/api/convos?Skip=${newSkip}`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (convoResponse.data.length === 0) {
      setNoMoreMessages(true);
    }
    setConvos((prevCon) => [...prevCon, ...convoResponse.data]);
    setSkip(newSkip);
  };

  const fetchMessages = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${ApiConnectionString}/api/convos?Skip=0`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      const sortedMessages = response.data.sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      );

      setConvos(sortedMessages);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [user.token]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (inboxRef.current && !inboxRef.current.contains(event.target)) {
        closeNoteAndInbox()
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div ref={inboxRef} className="inbox-container">
      {loading ? (
        <div className="loading-spinner">
          <LoadingSpinner />
        </div>
      ) : (
        <div>
          <div className="blueBanner text-center">
          <p className="fw-bold p-2">Messages</p>
            </div>

          <hr></hr>
          {convos.map((message) => (
            <div
              key={message.id}
              className={`inbox-card ${message.read ? "read" : "unread"}`}
              onClick={() => {
                navi(`/Convo/${message.id}`);closeNoteAndInbox();
              }}
            >
              <div className="d-flex">
                <img
                  src={
                    message.image
                      ? `${ApiConnectionString}/api/profileImageByAppUser/${message.userId}`
                      : ProfilePlaceHolder
                  }
                  alt="Profile Image"
                  className="profile-image"
                />
                <div>
                  <strong>{message.username}</strong>
                  <p>{new Date(message.timestamp).toLocaleString()}</p>
                </div>
              </div>
              <div>
                <p>{message.content}</p>
              </div>
              <hr />
            </div>
          ))}
          {convos.length === 0 && (
            <div className="no-messages-container">
              <Mailbox size={40} />
              <p className="no-messages-text">No messages yet</p>
              <p className="text-muted">New messages will appear here</p>
            </div>
          )}
        </div>
      )}
      {convos.length !== 0 &&
        (!noMoreMessages ? (
          <p onClick={ViewMoreNConvos} className="saveChanges-button">
            View More
          </p>
        ) : (
          <p className="text-muted">No more Messages</p>
        ))}
    </div>
  );
}
